(() => {
  const FIELDSET_SELECTOR = "[data-selected-color-target]";
  const VALUE_SELECTOR = "[data-selected-color-value]";

  const SWATCH_SELECTOR = '[data-selected-color-target] .bls__product-color-swatches';
  let activeTooltip = null;
  let keyboardInteraction = false;

  const closeTooltip = () => {
    if (!activeTooltip) return;
    activeTooltip.removeAttribute("data-tooltip-open");
    activeTooltip.closest(".swiper")?.classList.remove("show-tooltip");
    activeTooltip = null;
  };

  const openTooltip = (swatch) => {
    if (!swatch?.querySelector("[data-color-tooltip]")) return;
    if (activeTooltip !== swatch) closeTooltip();
    activeTooltip = swatch;
    swatch.setAttribute("data-tooltip-open", "");
    swatch.closest(".swiper")?.classList.add("show-tooltip");
  };

  const focusedSwatch = (target) => {
    if (target?.matches(`${SWATCH_SELECTOR}[role="radio"]`)) return target;
    if (!target?.matches('input[type="radio"]')) return null;
    const swatch = target.nextElementSibling;
    return swatch?.matches(SWATCH_SELECTOR) ? swatch : null;
  };

  // Delegation also covers cards inserted by sliders or the theme editor.
  document.addEventListener("pointerover", (event) => {
    if (event.pointerType === "touch") return;
    const swatch = event.target.closest(SWATCH_SELECTOR);
    if (!swatch || swatch.contains(event.relatedTarget)) return;
    keyboardInteraction = false;
    openTooltip(swatch);
  });

  document.addEventListener("pointerout", (event) => {
    if (!activeTooltip || keyboardInteraction) return;
    if (activeTooltip.contains(event.target) && !activeTooltip.contains(event.relatedTarget)) {
      closeTooltip();
    }
  });

  document.addEventListener("pointerdown", (event) => {
    keyboardInteraction = false;
    if (event.pointerType === "touch" || !activeTooltip?.contains(event.target)) closeTooltip();
  }, true);

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      if (activeTooltip) {
        closeTooltip();
        event.preventDefault();
        event.stopPropagation();
      }
      return;
    }
    if (["Tab", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Enter", " "].includes(event.key)) {
      keyboardInteraction = true;
      if (event.key !== "Tab") openTooltip(focusedSwatch(event.target));
    }
  }, true);

  document.addEventListener("focusin", (event) => {
    if (keyboardInteraction) openTooltip(focusedSwatch(event.target));
  });

  document.addEventListener("focusout", (event) => {
    if (focusedSwatch(event.target) === activeTooltip) closeTooltip();
  });

  const getSwatchLabel = (swatch) => {
    if (!swatch) return "";
    return (
      swatch.dataset?.value ||
      swatch.getAttribute("aria-label") ||
      swatch.getAttribute("title") ||
      swatch.textContent?.trim() ||
      ""
    );
  };

  const updateSelectedText = (fieldset) => {
    const targetId = fieldset?.dataset?.selectedColorTarget;
    if (!targetId) return;

    const labelTarget = fieldset.querySelector(".product-card-color-label");
    const valueNode = labelTarget?.querySelector(VALUE_SELECTOR);
    if (!valueNode) return;

    const activeSwatch =
      fieldset.querySelector(".bls__option-swatch-js.active") ||
      fieldset.querySelector('.bls__option-swatch-js[aria-checked="true"]');

    const fallback = fieldset.dataset?.defaultColor || "";
    const labelText = getSwatchLabel(activeSwatch) || fallback;

    if (labelText && valueNode.textContent !== labelText) {
      valueNode.textContent = labelText;
    }
  };

  const bindFieldset = (fieldset) => {
    if (!fieldset || fieldset.dataset.colorLabelBound === "true") return;
    fieldset.dataset.colorLabelBound = "true";

    const refresh = () => requestAnimationFrame(() => updateSelectedText(fieldset));
    fieldset.addEventListener("change", refresh);

    const observer = new MutationObserver(refresh);
    observer.observe(fieldset, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "aria-checked", "aria-selected"],
    });

    updateSelectedText(fieldset);
  };

  const init = (root = document) => {
    root.querySelectorAll(FIELDSET_SELECTOR).forEach(bindFieldset);
  };

  document.addEventListener("DOMContentLoaded", () => init());
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
